// 客户管理

export default [
  // 联系人级
  {
    path: '/customer/contact',
    component: () => import('@/views/customer/contact/List'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/contact/audit',
    component: () => import('@/views/customer/contact/Audit'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/contact/edit',
    component: () => import('@/views/customer/contact/Edit'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/contact/detail',
    component: () => import('@/views/customer/contact/Detail'),
    meta: {
      title: '万众国旅'
    }
  },
  // 营业部级
  {
    path: '/customer/operate',
    component: () => import('@/views/customer/operate/List'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/operate/edit',
    component: () => import('@/views/customer/operate/Edit'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/operate/audit',
    component: () => import('@/views/customer/operate/Audit'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/operate/detail',
    component: () => import('@/views/customer/operate/Detail'),
    meta: {
      title: '万众国旅'
    }
  },
  // 公司级
  {
    path: '/customer/company',
    component: () => import('@/views/customer/company/List'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/company/edit',
    component: () => import('@/views/customer/company/Edit'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/company/audit',
    component: () => import('@/views/customer/company/Audit'),
    meta: {
      title: '万众国旅'
    }
  },
  {
    path: '/customer/company/detail',
    component: () => import('@/views/customer/company/Detail'),
    meta: {
      title: '万众国旅'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/customer.js